import { ReactNode } from 'react';
import { DialogContent, DialogContentProps } from '@mui/material';

import { useFullScreenDialog } from '../FullScreenDialogContext';

export interface FullScreenDialogContentProps extends DialogContentProps {
    children: ReactNode;
}

export default function FullScreenDialogContent({ children, ...dialogContentProps }: FullScreenDialogContentProps) {
    const { contentRef } = useFullScreenDialog();

    return (
        <DialogContent ref={contentRef} {...dialogContentProps}>
            {children}
        </DialogContent>
    );
}
